import { connect } from 'react-redux';

import { getItemsList } from '../../Items/itemsActions';
import { getOfficesShortList, getPublicZoneList } from '../../Offices/officesActions';
import { exportOfficeSubtaskReport } from '../../Tasks/tasksActions';
import CampReadiness from './CampReadiness';
import { getCampReadinessDashboardData } from './CampReadinessActions';
import CampReadinessNew from './CampReadinessNew';

const mapStateToProps = state => ({
  officesShortList: state.office.officesShortList,
  itemsList: state.items.itemsList,
  campReadinessDashboardData: state.dashboard.campReadinessDashboardData,
  isLoading: state.dashboard.campReadinessIsLoading,
  publicZoneList: state.office.publicZoneList,
  exportOfficeSubtaskReportLoading: state.task.exportOfficeSubtaskReportLoading,
});
const mapDispatchToProps = dispatch => ({
  getOfficesShortList: params => dispatch(getOfficesShortList(params)),
  getItemsList: params => dispatch(getItemsList(params)),
  getCampReadinessDashboardData: params =>
    dispatch(getCampReadinessDashboardData(params)),
    getPublicZoneList: params => dispatch(getPublicZoneList(params)),
  exportOfficeSubtaskReport: value => dispatch(exportOfficeSubtaskReport(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CampReadinessNew);
